<div class="flex flex-col w-full gap-4">
  <div class="px-4 grid grid-cols-3 w-full items-center justify-between gap-2 text-violet-50 font-bold">
    <div class="flex items-center gap-2">
      <icon-edificio class="w-6 h-6"></icon-edificio>
      <p>{{ unidad }}</p>
    </div>
    <div class="flex items-center justify-center text-xl">
      <p class="cursor-pointer hover:text-blue-500" [routerLink]="'/admin'">{{sala || 'Seleccionar Sala...'}}</p>
    </div>
    <div class="flex items-center justify-end gap-2">
    </div>
  </div>
  <div class="flex-1 flex flex-col items-center justify-start w-full font-bold py-8 gap-4">
    <h1 class="text-7xl 2xl:text-9xl">TURNO EN ATENCIÓN</h1>
    <div class="grid grid-cols-2 items-center w-full px-4 gap-4 text-7xl 2xl:text-[150px]">
      <div class="w-full flex items-center justify-center py-6 px-4 h-full bg-blue-600">
        {{claveTurno}}
      </div>
      <div class="w-full flex flex-col items-center py-6 px-4 h-full bg-blue-600 text-7xl 2xl:text-[150px]">
        {{ turnoActual.puesto }}
      </div>
      <div class="w-full flex items-center justify-center py-6 px-4 h-full bg-blue-600">
        {{claveTurno2}}
      </div>
      <div class="w-full flex flex-col items-center py-6 px-4 h-full bg-blue-600 text-7xl 2xl:text-[150px]">
        {{ segundoturno.puesto }}
      </div>
      <div class="w-full flex items-center justify-center py-6 px-4 h-full bg-blue-600">
        {{claveTurno3}}
      </div>
      <div class="w-full flex flex-col items-center py-6 px-4 h-full bg-blue-600 text-7xl 2xl:text-[150px]">
        {{ tercerTurno.puesto }}
      </div>
    </div>
  </div>
  <div class="h-56 2xl:h-[480px] flex items-center justify-around">
    @if (multimedia1(); as multimedia) {
      <app-multimedia class="block flex-1 h-56 2xl:h-[480px]" [multimedia]="multimedia"></app-multimedia>
    } @else {
      <div class="block flex-1 h-56 2xl:h-[480px]"></div>
    }
    @if (multimedia2(); as multimedia) {
      <app-multimedia class="block flex-1 h-56 2xl:h-[480px]" [multimedia]="multimedia"></app-multimedia>
    } @else {
      <div class="block flex-1 h-56 2xl:h-[480px]"></div>
    }
  </div>
</div>
